module.exports = __webpack_public_path__ + "static/media/ebuilt-banner-desktop.9480481c.webp";